import { createReducer, on } from "@ngrx/store";
import { courseDetails } from "../actions/course.action";
import { Course } from '../models/course.model'

export const initialState: Course[] = []

export const courseReducer = createReducer(
    initialState,
    on(courseDetails, (state, { courseData }) => courseData)
)